<template>
  <div>
  <div class="list_video_related_standard" v-if="themeRelatedVideos=='standard'">
      <div class="header">
        Vidéos liées
      </div>

     <div class="list" v-for="video in relatedVideosOptions" :key="video.id" >


          <div class="video">
            <div class="card" v-on:click="setCurentUrl(video.url)">
              <div class="vignette16-9">
                <img  class="vignette" :src="video.vignette">
              </div>
              <div class="time">{{video.duration}}</div>
            </div>
            <div class="info">
              <div class="title">
                {{video.title}}
              </div>
              <div class="theme">
                Probabo inquit sic agam
              </div>
              <div class="date-vue">
                <div class="vue">66</div>
                <div class="date">13-04-2020</div>
              </div>

            </div>


          </div>


      </div>


  </div>




  <div class="list_video_related_Overlay"  v-if="themeRelatedVideos=='overlay'">

    <carousel
      navigation-prev-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
      navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
      :mouse-drag="true"
      :navigation-enabled="true"
      :pagination-enabled="false"
      :per-page-custom="[[320, 2], [576, 2], [768, 4], [992, 4], [1200, 4]]"
    >
      <slide  v-for="video in relatedVideosOptions" :key="video.id" class="one-video">
        <div class="video">
          <div class="card" v-on:click="setCurentUrl(video.url)">
            <div class="vignette16-9">
              <img  class="vignette" :src="video.vignette">
              <div class="blackshadow"></div>
            </div>
            <div class="time">{{video.duration}}</div>
          </div>
          <div class="info">
            <div class="title" :title="video.title">
              {{video.title}}
            </div>

            <!--
            <div class="theme">
              Probabo inquit sic agam
            </div>
            -->

          </div>
        </div>
      </slide>
    </carousel>





  </div>
  </div>

</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';

  export default {
        name: "RelatedVideoList",
    components: {

      Carousel,
      Slide

    },
      props: {
        relatedVideosOptions:Array,
        themeRelatedVideos:String
      }
      ,

      methods:{
        setCurentUrl(url){
          location=url

        }
      }
    }
</script>

<style scoped lang="scss">

   $mobile:576px ;
   $tab:992px ;


  .list_video_related_standard{
    width: 50%;

    .header{
      padding: 0.5em;
      background-color: #a3a3a3;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #262626;
    }

    .list {
      overflow-y: auto;
      padding: 0.5em;

      .video {
        display: flex;
        justify-content: space-between;


        .card {
          width: 200px;
          cursor: pointer;

          &:hover{
            filter: blur(1px);
          }
          .vignette16-9{
            transition: .3s;
            width: 100%;
            justify-content: center;
          display: inline-block;
          position: relative;
          padding-bottom: 56.2%;
          }

          .vignette{
            height: 100%;
            border-radius: 3px;
            width: 100%;
            position: absolute;
            -o-object-fit: cover;
            object-fit: cover;
            margin: auto;

          }
          .time {
            position: absolute;
            right: 0;
            bottom: 0;
            opacity: 0.8;
            border-radius: 1.2px;
            background-color: #000000;
            color: white;
            padding: 0.2em 0.8em;
            margin: 0.5em;
            font-size: 15px;
          }
        }


        .info{
          width: 100%;
          padding: 0 0.5em;
            .title{
              font-size: 16px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #262626;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .theme{
              font-size: 14px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              letter-spacing: normal;
              color: #6f6f6f;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .date-vue{
              display: flex;
              /*justify-content: space-between;*/
              .date{
                margin-left: 1em;
              }
              .date , .vue{
                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #6f6f6f;

              }
            }


        }
      }

    }





  }


   .list_video_related_Overlay{

    z-index: 9;

    width: calc(100% - 30px);
    position: absolute;
    bottom: 50px;
    margin:0 30px ;




    .video {
      display: flow-root;
      padding: 1em;

      .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.7), 0 6px 20px 0 rgba(0, 0, 0, 0.51);
        cursor: pointer;
        border: none!important;
        border-radius: 0!important;
        &:hover{
          filter: blur(1px);
        }
        .vignette16-9{
          transition: .3s;
          width: 100%;
          justify-content: center;
          display: inline-block;
          position: relative;
          padding-bottom: 56.2%;
        }
        .blackshadow{
          background-color: rgba(0, 0, 0, 0.44);
          position: absolute;
          top:0;
          width: 100%;
          height: 100%;
        }
        .vignette{
          height: 100%;
          border-radius: 3px;
          width: 100%;
          position: absolute;
          -o-object-fit: cover;
          object-fit: cover;
          margin: auto;

        }
        .time {
          position: absolute;
          right: 0;
          bottom: 0;
          opacity: 0.8;
          border-radius: 1.2px;
          background-color: #000000;
          color: white;
          padding: 0.2em 0.8em;
          margin: 0.5em;
          font-size: 15px;
        }
      }


      .info{
        padding-top: 0.5em;
        width: 100%;
        .title{
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.21;
          letter-spacing: normal;
          color: #f5f5f5;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .theme{
          font-size: 13px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #a7a7a7;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }




      }
    }



  }





   /*Carousel*/
  .VueCarousel {
    width: calc(100% - 32px);
  }
   .VueCarousel-slide {
     max-width: 25%;
   }


  @media screen and (max-width: 960px){
    /*.video-player{
      display: grid!important;
    }*/
    .list_video_related_standard{
      width: 100%;
    }

  }
  @media screen and (max-width: 460px) {
    .list_video_related_standard {
      .header {
        font-size: 19px;
      }

      .list {
        .video {
          .card {
            .time {
              font-size: 13px;
            }
          }

          .info {
            .title {
              font-size: 14px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #262626;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 200px);
            }

            .theme {
              font-size: 13px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              letter-spacing: normal;
              color: #6f6f6f;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 200px);

            }

            .date-vue {

              .date, .vue {
                font-size: 13px;

              }


            }
          }

        }


      }

    }
  }


   @media screen and (max-width: $tab) {

   }

  @media screen and (max-width: $mobile) {



    .list_video_related_Overlay{





      .video {

        .card {
          .vignette16-9{
            transition: .3s;
            width: 100%;
            justify-content: center;
            display: inline-block;
            position: relative;
            padding-bottom: 56.2%;
          }


          .vignette{
            height: 100%;
            border-radius: 3px;
            width: 100%;
            position: absolute;
            -o-object-fit: cover;
            object-fit: cover;
            margin: auto;

          }
          .time {
            position: absolute;
            right: 0;
            bottom: 0;
            opacity: 0.8;
            border-radius: 1.2px;
            background-color: #000000;
            color: white;
            padding: 0.2em 0.8em;
            margin: 0.5em;
            font-size: 15px;
          }
        }


        .info{
          position:absolute;
          top: 1em;
          width: calc(50% - 1.5em);
          padding:0.5em;
          .title{
            font-size: 13px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.31;
            letter-spacing: normal;
            color: #f5f5f5;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .theme{
            font-size: 12px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #f5f5f5;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }




        }
      }



    }


    .VueCarousel-slide {
      max-width: 50%;
    }
  }
   .VueCarousel-navigation-button:focus {
     outline: none !important;
   }


</style>



// WEBPACK FOOTER //
// src/components/RelatedVideosComponents/RelatedVideoList.vue